// For color mapping see docs:
// https://getbootstrap.com/docs/5.0/components/badge/#background-colors
export const bsClassForOperationStatus = (op) => {
    switch (op.status) {
        case "APPROVED":
            return "bg-success";
        case "PENDING":
            return "bg-warning text-dark";
        case "EXPIRED":
            return "bg-secondary";
        case "CANCELED":
            return "bg-light text-dark";
        case "REJECTED":
            return "bg-primary";
        case "FAILED":
            return "bg-danger";
    }
};
